import { hasF2, f2 } from '../copyFlow2'
import { kindText, slugLabel } from '../lib/format'
import { Symbol } from './Symbol'

/**
 * R8 ("Other" on a history museum, "Fitness" on a bowling alley): a catch-all category reads as its first tag that
 * has a label in the copy file (`tag.<slug>`, else `category.<slug>`); with none, the category as before.
 */
export function categoryText(category: string, tags?: readonly string[] | null): string {
  if (category === 'other' || (category === 'fitness' && tags?.includes('games'))) {
    for (const t of tags ?? []) {
      const key = [`tag.${t}`, `category.${t.replace(/-/g, '_')}`].find(hasF2)
      if (key) return f2(key)
    }
  }
  return slugLabel(category, true)
}

/** Category label (Astra §4): a mark in the category color, 8px gap, eyebrow text. Never implies state. 10/18: the first
 *  level-2 kind follows the category ("Music · Jazz"; kind words: Astra's short eyebrow names, copyKinds.ts). */
export function CategoryLabel({ category, tags, className = '' }: { category: string; tags?: readonly string[] | null; className?: string }) {
  return (
    <span data-cat={category} className={`inline-flex items-center gap-2 text-ink ${className}`}>
      <Symbol cat={category} size={20} />
      <span className="t-eyebrow text-ink-2">{categoryText(category, tags)}{kindText(tags) ? ` · ${kindText(tags)}` : ''}</span>
    </span>
  )
}
